//@flow
import * as Immutable from 'immutable';

import {
    TerritoryOutletInfo,
    MasterTerritory,
    MasterTerritoryPlan,
    TerritoryMetrics,
    TerritoryOutletId
} from 'common/models/flow/MasterTerritoryPlan';
import type {
    TerritoryOutletInfoModelType,
    MasterTerritoryModelType,
    MasterTerritoryPlanModelType,
    TerritoryMetricsModelType,
    TerritoryOutletIdModelType
} from 'common/models/flow/MasterTerritoryPlan';
import { MasterOutlet } from './MasterOutlet';
import { AuditMetadata } from './AuditMetadata';
import { Actor } from './Actor';

class InternalTerritoryOutletInfo extends TerritoryOutletInfo {
    static fromJS(
        json: TerritoryOutletInfoModelType
    ): InternalTerritoryOutletInfo {
        const state: Object = Object.assign({}, json);
        state.outletIds = Immutable.List(state.outletIds).map(item =>
            InternalTerritoryOutletId.fromJS(item)
        );
        state.outlets = state.outlets
            ? Immutable.List(state.outlets).map(item =>
                  MasterOutlet.fromJS(item)
              )
            : state.outlets;
        return new this(Immutable.Map(state));
    }

    get outlets(): ?Immutable.List<MasterOutlet> {
        return this._state.get('outlets');
    }

    get outletIds(): Immutable.List<TerritoryOutletId> {
        return this._state.get('outletIds');
    }
}

class InternalMasterTerritory extends MasterTerritory {
    static fromJS(json: MasterTerritoryModelType): InternalMasterTerritory {
        const state: Object = Object.assign({}, json);
        state.customProperties = Immutable.Map(state.customProperties);
        state.auditMetadata = state.auditMetadata
            ? AuditMetadata.fromJS(state.auditMetadata)
            : state.auditMetadata;
        state.outletsInfo = InternalTerritoryOutletInfo.fromJS(
            state.outletsInfo
        );
        state.metrics = InternalTerritoryMetrics.fromJS(state.metrics);
        return new this(Immutable.Map(state));
    }

    get outletsInfo(): InternalTerritoryOutletInfo {
        return this._state.get('outletsInfo');
    }

    get auditMetadata(): ?AuditMetadata {
        return this._state.get('auditMetadata');
    }

    get metrics(): InternalTerritoryMetrics {
        return this._state.get('metrics');
    }
}

class InternalMasterTerritoryPlan extends MasterTerritoryPlan {
    static fromJS(
        json: MasterTerritoryPlanModelType
    ): InternalMasterTerritoryPlan {
        const state: Object = Object.assign({}, json);
        state.customProperties = Immutable.Map(state.customProperties);
        state.auditMetadata = state.auditMetadata
            ? AuditMetadata.fromJS(state.auditMetadata)
            : state.auditMetadata;
        state.territories = Immutable.List(state.territories).map(item =>
            InternalMasterTerritory.fromJS(item)
        );
        state.actor = Actor.fromJS(state.actor);
        return new this(Immutable.Map(state));
    }

    get territories(): Immutable.List<MasterTerritory> {
        return this._state.get('territories');
    }

    get auditMetadata(): ?AuditMetadata {
        return this._state.get('auditMetadata');
    }

    get actor(): Actor {
        return this._state.get('actor');
    }
}

class InternalTerritoryMetrics extends TerritoryMetrics {
    static fromJS(json: TerritoryMetricsModelType): InternalTerritoryMetrics {
        const state: Object = Object.assign({}, json);
        return new this(Immutable.Map(state));
    }
}

class InternalTerritoryOutletId extends TerritoryOutletId {
    static fromJS(json: TerritoryOutletIdModelType): InternalTerritoryOutletId {
        const state: Object = Object.assign({}, json);
        return new this(Immutable.Map(state));
    }
}

export {
    InternalTerritoryOutletInfo as TerritoryOutletInfo,
    InternalMasterTerritory as MasterTerritory,
    InternalMasterTerritoryPlan as MasterTerritoryPlan,
    InternalTerritoryMetrics as TerritoryMetrics,
    InternalTerritoryOutletId as TerritoryOutletId
};
